import request from "./request";
import axiosSignatureX from "../assets/js/common/http-InterceptorX/HttpInterceptorX";

export function get(path, data) {
  return request.GET(path, data);
}

// 学习中心 - 我的资源 - 已下载资源 - 获取下载资源列表
export const getDownloadList = function (data) {
  return axiosSignatureX.get(
    process.env.VUE_APP_SOURCE_API +
      "/v1/user/getDownloadLogByUserName?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize
  );
};

// 学习中心 - 我的资源 - 已收藏资源 - 获取收藏资源列表
export const getFavoriteList = function (data) {
  return request.GET("/api/source/mp/favorite/v1/list", data);
};

// // 学习中心 - 订阅课程 - 视频课 - 免费课列表
export const getSubscribeCourseList = function () {
  return request.GET("/api/edu/core-api/v1/subscribe/list?type=course");
};

// // 学习中心 - 订阅课程 - 视频课 - 付费课程列表
export const getVideoCourseList = function (data) {
  return request.GET("/api/edu/core-api/v1/videoCourse/list", data);
};

// // 学习中心 - 订阅课程 - 视频课 - VIP课程列表
export const getSubscribeVIPCourseList = function () {
  return request.GET("/api/edu/core-api/v1/subscribe/list?type=vipCourse");
};

// // 学习中心 - 订阅课程 - 直播训练营 - 获取直播训练营
export const getLiveVideoList = function (data) {
  return axiosSignatureX.get(
    process.env.VUE_APP_COLLEGE_API +
      "/edu-academy-web/v1/live/course/bought?page=" +
      data.page +
      "&size=" +
      data.size
  );
};

// 学习中心 - 订阅课程 - 特训班 - 获取特训班列表
export const getTeachVideoList = function (data) {
  return axiosSignatureX.get(
    process.env.VUE_APP_COLLEGE_API +
      "/edu-academy-web/v1/course/teach/buy?page=" +
      data.page +
      "&pageSize=" +
      data.pageSize
  );
};

// 学习中心 - 订阅课程 - 极客时间 - 获取极客时间数据列表，【'领域会员卡','视频课程','专栏课程','学习记录'】
export const getGeekTimeData = function (data) {
  return request.GET(
    `${process.env.VUE_APP_DEVPRESS_API}/v1/study/record`,
    data 
  );
};

// 学习中心 - 订阅专栏 - 精品专栏 - 精品专栏
export const getGitchatList = function (data) {
  return request.GET("/api/edu/gitchat/order", data);
};

// 学习中心 - 订阅专栏 - 图文专栏 - 图文专栏
export const getSubscibeList = function (data) {
  return request.GET("/api/edu/blog/getSubscibeList", data);
};

// 学习中心 - 电子书架 - 电子书架 - 电子书架
export const getEbookList = function (data) {
  return request.GET("/api/edu/ebook/getMyEbookShelf", data);
};

// 学习中心 - 个人信息 - 我的权益
export const getLoginInfo = function (data) {
  return request.GET("/api/wk/v2/obtainUserLoginInfo", data);
};

// 学习中心 - 个人信息 - 我的证书
export const getCertificates = function (data) {
  return axiosSignatureX.get(
    process.env.VUE_APP_COLLEGE_API +
      "/edu-academy-web/v1/evaluation/course/certificates"
  );
};

// 学习中心 - 个人信息 - 热门推荐
export const getRecommendList = function (data) {
  return request.GET("/api/wk/v2/obtainCourseHotRecommend", data);
};

/**
 * 获取学院toolbar
 * @param {*} type
 * @returns
 */
export const getEduMenu = (data) => {
  return request
    .GET("https://edu-core-api.csdn.net/academy-pc/v1/toolbar/config/get", data)
    .then((response) => {
      return response
    });
};
